import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';
import Pressable from '@atlaskit/primitives/pressable';

type SelectToggleIconProps = {
	isSelected: boolean;
	onClick: () => void;
	ariaLabel: string;
};

const styles = cssMap({
	pressable: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingBlock: token('space.150'),
		paddingInlineStart: token('space.200'),
		paddingInlineEnd: token('space.200'),
		backgroundColor: 'transparent',
		flexShrink: 0,
		'&:hover': {
			// @ts-expect-error
			backgroundColor: 'transparent',
		},
	},
	highlightRing: {
		width: '16px',
		height: '16px',
		marginBlock: token('space.negative.075'),
		marginInline: token('space.negative.075'),
		borderRadius: token('radius.full'),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'&:hover': {
			backgroundColor: token('color.background.neutral.hovered'),
		},
	},
	iconWrapper: {
		position: 'relative',
		width: '16px',
		height: '16px',
		flexShrink: 0,
	},
	iconLayer: {
		position: 'absolute',
		top: 0,
		left: 0,
		transition: 'opacity 250ms ease, transform 250ms ease',
	},
	iconLayerVisible: {
		opacity: 1,
		transform: 'scale(1)',
	},
	iconLayerHidden: {
		opacity: 0,
		transform: 'scale(0.75)',
	},
});

export const SelectToggleIcon = ({ isSelected, onClick, ariaLabel }: SelectToggleIconProps) => (
	<Pressable xcss={styles.pressable} onClick={onClick} aria-label={ariaLabel}>
		<Box xcss={styles.highlightRing}>
			<Box xcss={styles.iconWrapper}>
				<Box
					xcss={cx(styles.iconLayer, isSelected ? styles.iconLayerVisible : styles.iconLayerHidden)}
				>
					<CheckCircleIcon label="" color={token('color.icon')} />
				</Box>
				<Box
					xcss={cx(styles.iconLayer, isSelected ? styles.iconLayerHidden : styles.iconLayerVisible)}
				>
					<CrossCircleIcon label="" color={token('color.icon.subtle')} />
				</Box>
			</Box>
		</Box>
	</Pressable>
);
